<footer class=" text-light" style="background-color: #0f172b;">
    <div class="container-fluid pt-0 pb-0">
        <div class="container pt-3 pb-3">
            <div class="row align-items-center gy-4">
                <div class="col-md-3 text-center text-md-start">
                    <a href="/job-list-one" class="d-inline-block" aria-label="Job List">
                        <img src="../../../../assets/images/new-images/OUK_Logo 1.png" alt="Logo">
                    </a>
                </div>
                <div class="col-md-9 small">
                    <ul class="list-inline text-center text-md-end mb-0">
                        <li class="list-inline-item mx-2">
                            <a href="#" class="link-light text-decoration-none">About Us</a>
                        </li>
                        <li class="list-inline-item mx-2">
                            <a href="#" class="link-light text-decoration-none">Contact Us</a>
                        </li>
                        <li class="list-inline-item mx-2">
                            <a href="#" class="link-light text-decoration-none">Terms and Conditions</a>
                        </li>
                        <li class="list-inline-item mx-2">
                            <a href="#" class="link-light text-decoration-none">Refund Policy</a>
                        </li>
                        <li class="list-inline-item mx-2">
                            <a href="#" class="link-light text-decoration-none">Privacy Policy</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <hr class="border-secondary mt-0 mb-0">
        <div class="container pt-4 pb-4">
            <div class="row align-items-center text-center text-md-start">
                <div class="col-md-12  text-center">
                    <p class="mb-0 small">&copy; 2025 OUK. All Rights Reserved. Powered by
                        <a href="https://www.dhanushhealthcare.com/" target="_blank"
                            class="link-light text-decoration-none">Dhanush Healthcare Systems</a>
                    </p>
                </div>

            </div>
        </div>
    </div>
</footer>



<!-- 
<footer>
    <div class="container-fluid ">
        <div class="row p-5 bg-footer">

            <div class="col-xl-9 col-md-6">
                <h5>About OUK</h5>
                <ul class="footer-links">
                    <li><a [routerLink]="'/eRP/about-us'">About Us</a></li>
                    <li><a [routerLink]="'/eRP/contact-us'">Contact Us</a></li>
                    <li><a [routerLink]="'/eRP/terms-conditions'">Terms and Conditions</a></li>
                    <li><a [routerLink]="'/eRP/refund-policy'">Refund Policy</a></li>
                    <li><a [routerLink]="'/eRP/privacy-policy'">Privacy Policy</a></li>
                </ul>
            </div>
            <div class="col-xl-3 col-md-6">
                <h5>Contact</h5>
                <ul class="contact-links">
                    <li><a href="#" class="text-white">info@ouk.com</a></li>
                    <li><a href="#" class="text-white">(+254) 4049135000</a></li>
                    <li>
                        <hr class="m-0 mb-2">
                        <div>
                            <form class="well form-horizontal" [formGroup]="myForm" (onSubmit)="onSubmitForm(myForm)">
                                <div class="mb-2">
                                    <input type="text" class="form-control" id="exampleFormControlInput1"
                                        formControlName="CONTACT_NAME" placeholder="Name"
                                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'>
                                </div>
                                <div class="mb-2">
                                    <input type="email" class="form-control" id="txtemail" email="true"
                                        formControlName="CONTACT_EMAILID" placeholder="name@example.com"
                                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                        (change)="validateEmail($event.target.value)">
                                </div>
                                <div class="mb-2">
                                    <textarea class="form-control" id="exampleFormControlTextarea1"
                                        formControlName="CONTACT_DESCRIPTION" placeholder="Enter Description"
                                        rows="2"></textarea>
                                </div>
                                <div class="">
                                    <button type="button" (click)="onSubmitForm(myForm)"
                                        class="btn btn-sm btn-style-1">Submit</button>
                                </div>
                            </form>
                        </div>
                    </li>
    

                </ul>
            </div>
        </div>

        <app-main-footer></app-main-footer>

    </div>

</footer> -->